import {InjectionKey} from "vue"

export const LoginSuccessActionKey: InjectionKey<(url: string) => void> = Symbol("LoginSuccessAction")
